import React from "react";

const SubjectIcon = (props: any) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 43 43"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4230_55191)">
          <path
            d="M15.0501 2.08984H34.1101C35.2301 2.08984 36.1401 2.99984 36.1401 4.10984V38.3998C36.1401 39.5198 35.2301 40.4298 34.1101 40.4298H10.6201C9.50009 40.4298 8.59009 39.5198 8.59009 38.3998V8.92984"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
          <path
            d="M30.0701 19.4002H14.9101C14.4401 19.4002 14.0601 19.0202 14.0601 18.5502V12.8402C14.0601 12.3702 14.4401 11.9902 14.9101 11.9902H30.0701C30.5401 11.9902 30.9201 12.3702 30.9201 12.8402V18.5502C30.9201 19.0202 30.5401 19.4002 30.0701 19.4002Z"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
          <path
            d="M30.9199 25.9401H14.0599C13.9299 25.8201 13.3999 25.3001 13.3399 24.4401C13.2699 23.4001 13.9599 22.7301 14.0599 22.6401C19.6799 22.6401 25.2999 22.6401 30.9199 22.6401C31.0199 22.7301 31.6699 23.3101 31.6699 24.2901C31.6699 25.2701 31.0199 25.8501 30.9199 25.9401Z"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
          <path
            d="M30.9199 31.4001H14.0599C13.9299 31.2801 13.3999 30.7601 13.3399 29.9001C13.2699 28.8601 13.9599 28.1901 14.0599 28.1001C19.6799 28.1001 25.2999 28.1001 30.9199 28.1001C31.0199 28.1901 31.6699 28.7701 31.6699 29.7501C31.6699 30.7301 31.0199 31.3101 30.9199 31.4001Z"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
          <path
            d="M30.9099 36.8601H14.0499C13.9199 36.7401 13.3899 36.2201 13.3299 35.3601C13.2599 34.3201 13.9499 33.6501 14.0499 33.5601C19.6699 33.5601 25.2899 33.5601 30.9099 33.5601C31.0099 33.6501 31.6599 34.2301 31.6599 35.2101C31.6599 36.1901 31.0099 36.7701 30.9099 36.8601Z"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
          <path
            d="M8.80005 9.43985H14.86C14.97 9.43985 15.0601 9.34985 15.0601 9.23985V2.28985C15.0601 2.10985 14.83 2.01985 14.71 2.15985L8.65005 9.10985C8.54005 9.23985 8.63005 9.43985 8.80005 9.43985Z"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_4230_55191">
            <rect width="42.52" height="42.52" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default SubjectIcon;
